export default {
  getList: {
    method: 'post',
    url: '/admincp/system/users/list'
  },
  updateRoles: {
    method: 'post',
    url: '/admincp/system/users/ID/roles'
  }
}
